import { render, staticRenderFns } from "./LatestRidesSidebar.vue?vue&type=template&id=6b5d95b5&scoped=true&"
import script from "./LatestRidesSidebar.vue?vue&type=script&lang=js&"
export * from "./LatestRidesSidebar.vue?vue&type=script&lang=js&"
import style0 from "./LatestRidesSidebar.vue?vue&type=style&index=0&id=6b5d95b5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5d95b5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
